import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {greys} from "@irati/ui/src/global/colors"
import {STATUS_CLOSED, STATUS_OPEN, STATUS_SCHEDULED} from "@irati/insights/constants/survey"

import {Image} from "../../../ui/Image"
import StatusScheduledIcon from "../../../../images/survey/statusScheduled.svg"
import StatusOpenIcon from "../../../../images/survey/statusOpen.svg"
import StatusClosedIcon from "../../../../images/survey/statusClosed.svg"

const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  width:100%;
  height:100%;
  position: relative;
`
const VerticalLine = styled.div`
  border-left: 2px dotted;
  border-color: ${greys.mediumLight};
  height: ${({isLast}) => (isLast ? "50%" : "100%")};
  position: absolute;
  top: 0;
  left: 49%;
  margin-top: ${({isFirst}) => (isFirst ? "100%" : 0)};
`
const StyledImage = styled(Image)`
  z-index: 1;
`

const getIcon = (status) => {
  switch (status) {
    case STATUS_OPEN:
      return StatusOpenIcon
    case STATUS_CLOSED:
      return StatusClosedIcon
    case STATUS_SCHEDULED:
      return StatusScheduledIcon
    default:
      return StatusClosedIcon
  }
}

const IconCellRenderer = ({row, rowCount, ...props}) => {
  const idNamespace = id("IconCellRenderer", props)
  const icon = getIcon(row.status)
  return (
    <Cell id={idNamespace}>
      {rowCount > 1 && <VerticalLine isFirst={row._index === 0} isLast={row._index === rowCount - 1} />}
      <StyledImage src={icon} alt="" size={29} />
    </Cell>
  )
}

IconCellRenderer.propTypes = {
  row: PropTypes.object,
  rowCount: PropTypes.number
}

IconCellRenderer.defaultProps = {
  row: {},
  rowCount: 0
}

export default IconCellRenderer
